import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const updateSalesReviewData = (salesReviewId, payload, callback, errCb) => {
  return async (dispatch) => {
    dispatch({ type: 'UPDATING_SALES_REVIEW_DATA' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.put(
            `/ads/sale-reviews/${salesReviewId}`,
            payload,
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'UPDATING_SALES_REVIEW_DATA_DONE',
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'UPDATING_SALES_REVIEW_DATA_FAILED',
              payload: `Failed to update sales review data`,
            });
            if (typeof errCb === 'function') {
              errCb();
            }
          }
        } catch (e) {
          dispatch({
            type: 'UPDATING_SALES_REVIEW_DATA_FAILED',
            payload: `Failed to update sales review data`,
          });
          if (typeof errCb === 'function') {
            errCb();
          }
        }
        unsubscribe();
      });
    } catch (e) {
      console.log(e);
      dispatch({
        type: 'UPDATING_SALES_REVIEW_DATA_FAILED',
        payload: `Failed to update sales review data`,
      });
      if (typeof errCb === 'function') {
        errCb();
      }
    }
  };
};

export default updateSalesReviewData;
